import Tooltip from '@mui/material/Tooltip';
import cn from 'classnames';
import React from 'react';
import { formatAmount, formatHoldingsInIssuer } from 'stores/financeUtils';
import { IOfferingInfo } from 'utils/globalTypes';

import s from './InvestmentHolding.module.scss';

interface IInvestmentHolding {
  className?: string;
  onClick: () => void;
  item: IOfferingInfo;
}

const InvestmentHolding = ({ className, onClick, item }: IInvestmentHolding) => {
  const {
    quantity_holding_investor,
    volume_holding_investor,
    offering_quantity,
    quantity,
    currency
  } = item;

  if (!volume_holding_investor || (!offering_quantity && !quantity)) {
    return null;
  }

  return (
    <div className={cn(s.InvestmentHolding, className)} onClick={onClick}>
      {quantity_holding_investor ? (
        <Tooltip
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 220
              }
            }
          }}
          title={`Your holding represents ${formatHoldingsInIssuer(
            quantity_holding_investor,
            offering_quantity || quantity
          )} ownership interest in the asset`}
        >
          <div className={cn(s.InvestmentHolding__label, 'own')}>
            {'I own'}
            <span className={s.InvestmentHolding__value}>{` ${formatHoldingsInIssuer(
              quantity_holding_investor,
              offering_quantity || quantity
            )} in Issuer `}</span>
            {formatAmount(volume_holding_investor, currency, 0)}
          </div>
        </Tooltip>
      ) : (
        <div className={cn(s.InvestmentHolding__label, 'own')}>
          {`I own ${formatAmount(volume_holding_investor, currency, 0)}`}
        </div>
      )}
    </div>
  );
};

export default InvestmentHolding;
